import { useState } from 'react';
import { ImageOff } from 'lucide-react';
import { fotoProduk } from '../lib/foto';

/**
 * Kotak foto mini untuk daftar pilihan produk.
 *
 * Tiga hal yang dijaga supaya layar pengisian order tidak jadi berat:
 *  1. loading="lazy" — hanya foto yang benar-benar terlihat yang diunduh.
 *  2. ukuran kotak tetap — tidak ada pergeseran tata letak saat foto datang.
 *  3. produk tanpa foto tidak memanggil jaringan sama sekali.
 *
 * HANYA foto asli yang diunggah sendiri yang ditampilkan. Gambar contoh dari
 * layanan foto stok sengaja TIDAK dipakai di sini: gunanya kotak ini adalah
 * memastikan karyawan tidak salah pilih barang, dan foto yang bukan barangnya
 * justru lebih menyesatkan daripada kotak kosong.
 */
export function FotoMini({ product, size = 34, ratio = 1.25, testid }) {
  const [rusak, setRusak] = useState(false);
  const src = product?.has_photo ? fotoProduk(product, true) : '';
  const gaya = { width: size, height: Math.round(size * ratio), flex: `0 0 ${size}px` };

  if (!src || rusak) {
    return (
      <div style={gaya} data-testid={testid ? `${testid}-kosong` : undefined}
        className="rounded-md bg-ivory border border-border/70 flex items-center justify-center text-mocha/50">
        <ImageOff size={Math.round(size * 0.42)} />
      </div>
    );
  }
  return (
    <img
      src={src}
      alt=""
      loading="lazy"
      decoding="async"
      draggable={false}
      onError={() => setRusak(true)}
      style={gaya}
      data-testid={testid}
      className="rounded-md object-cover bg-ivory border border-border/70"
    />
  );
}
